import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gpu-cloud',
  templateUrl: './gpu-cloud.component.html',
  styleUrls: ['./gpu-cloud.component.css']
})
export class GpuCloudComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
